// import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Router from './modules/routes/Router.tsx';
import './i18n/config';
import './lib/otel';
import './lib/sentry';
import ErrorBoundary from './pages/app/components/ErrorBoundary.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
  // </React.StrictMode>,
)
